module.exports = __webpack_public_path__ + "static/media/ladybugs.f5729151.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/ladybugs.png
// module id = 316
// module chunks = 0